import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const relatedTitles: AdminBlockTypeAttribute = {
  label: 'Show related articles',
  key: 'relatedTitles',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default relatedTitles;
